import { useAPIRequest } from '~/composables/api/useAPIRequest'

export async function useNewsListingTags() {
  return await useAPIRequest('/tags')
}
